/**
 * NoteUpdatedBanner — confirmation card surfaced after update_deal_notes.
 *
 * HANDOFF_AI_CHAT_FEATURE_V1_REVISED visual-feedback addendum (S21).
 */
import { Check } from 'react-feather';

import type { ToolResultProps } from '../lib/component-registry';

interface NoteResult {
  deal_id: number;
  deal_notes: string;
  status_label?: string | null;
}

export function NoteUpdatedBanner({ result }: ToolResultProps) {
  const r = (result ?? {}) as Partial<NoteResult>;
  if (!r || !r.deal_id) {return null;}
  const body = stripStatusPrefix(r.deal_notes ?? '');
  return (
    <div className="mt-2 flex items-start gap-2 border border-success/40 bg-success/5 px-3 py-2 text-body-sm">
      <Check size={16} className="mt-0.5 shrink-0 text-success" strokeWidth={2.5} />
      <div className="min-w-0">
        <p className="font-semibold text-txt-primary">Deal note updated</p>
        {body && (
          <p className="mt-1 whitespace-pre-line text-txt-secondary">{body}</p>
        )}
      </div>
    </div>
  );
}

function stripStatusPrefix(notes: string): string {
  return notes.replace(/^\[STATUS: [^\]]+\]\n?/, '').trim();
}
